import React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Logo from 'src/components/atoms/Logo'
import SiteNav from 'src/components/organisms/SiteNav'
import Footer from 'src/components/organisms/Footer'

export const LayoutLight = ({children}: {children: React.ReactNode}) => (
  <>
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: {
          md: 8,
          xs: 3,
        },
        backgroundColor: 'transaprent',
        mb: {
          md: -19,
          xs: -9,
        },
      }}
    >
      <Box sx={{minWidth: 86, width: 86, mr: 12, margin: '0 auto'}}>
        <Logo />
      </Box>
    </Container>
    {children}
  </>
)

const Layout = ({children}: {children: React.ReactNode}) => (
  <>
    <SiteNav />
    {children}
    <Footer />
  </>
)

export default Layout
